import {QueryParams, QueryParamValue} from "@web-libs/core/http/api/http.types";

type QueryParamsPair = [string, QueryParamValue | QueryParamValue[]]
type StringPair = [string, string]

export  const addQueryString = (url: string, queryParams?: QueryParams) => {
    const builtQueryString = buildQueryString(queryParams)?.toString()
    return builtQueryString ? `${url}?${builtQueryString}` : url
}
const buildQueryString = (queryParams?: QueryParams) => {
    if (!queryParams) return null
    const queryParamPairs = toPairs(queryParams)
    const stringPairs = toStringPairs(queryParamPairs)
    return new URLSearchParams(stringPairs)
}

const toPairs = (value: QueryParams): QueryParamsPair[] => Object.entries(value)

const toStringPairs = (pairs: QueryParamsPair[]): StringPair[] =>
    pairs
    .map(mapPairToStringPair)
    .filter(pair => pair) as StringPair[]

const mapPairToStringPair = (pair: QueryParamsPair): StringPair|undefined => {
    const [key, value] = pair
    if (value === undefined) return
    if (typeof value === 'string') {
        return [key, value]
    } else if (Array.isArray(value)) {
        return  arrayToStringPair(key, value)
    } else {
        return [key, value.toString()]
    }
}

function arrayToStringPair( key: string, value: any[]): StringPair | undefined {
    if (value.length === 0) return
    return [key, translateArrayToString(value)];
}

const translateArrayToString = (value: QueryParamValue[]): string => {
    return value.map(val => val?.toString()).join(',')
}
